import React, { useEffect, useRef, useState } from "react";
import {
  EditorState,
  convertToRaw,
  convertFromRaw,
} from "draft-js";
import styles from "./DraftEditor.module.scss";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Button, {BUTTON_TYPE_PRIMARY, BUTTON_TYPE_SECONDARY} from "../Button/Button";
import NewButton from "../ButtonNew/Button";
import Modal, {MODAL_SIZE_FULL} from "../Modal/Modal";


const DraftEditor = (props) => {
  const {
    open,
    setClose,
    valueHTML,
    setFinishedHtml
  } = props;

  const [editorState, setEditorState] = useState(
    EditorState.createEmpty()
  );
  const [editorStateSaved, setEditorStateSaved] = useState(false);
  const [darkMode, setDarkMode] = useState(true);

  useEffect(() => {
    if (valueHTML && editorStateSaved === false) {
      setEditorState(EditorState.createWithContent(convertFromRaw(valueHTML)))
      setEditorStateSaved(true);
    }
  }, [valueHTML]);

  const saveHTML = () => {
    setClose();
    setFinishedHtml(convertToRaw(editorState.getCurrentContent()));
  }

  return (
    <Modal
        show={open}
        setShow={setClose}
        onConfirm={saveHTML}
        confirmButtonText={"SAVE HTML"}
        exit
        type={MODAL_SIZE_FULL}
        header="Content Editor">
      <div className={styles.darkModeButtonContainer}>
        {darkMode ?
          <NewButton
            text="Toggle Dark Mode"
            onClick={() => setDarkMode(!darkMode)}
          />
         : <Button
            buttonType={BUTTON_TYPE_SECONDARY}
            text="Toggle Dark Mode"
            onClick={() => setDarkMode(!darkMode)}/>}
      </div>
      <div className={styles.editorOuterContainer}>
        <div className={darkMode ? styles.editorWrapperDark : styles.editorWrapperLight}>
          <Editor
              placeholder="Write Here"
              editorState={editorState}
              toolbarClassName="toolbarClassName"
              editorClassName={styles.draftInnerWrapper}
              onEditorStateChange={(editorState) => {
                setEditorState(editorState);
              }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default DraftEditor;
